import { render, staticRenderFns } from "./VSearchProfileForm.vue?vue&type=template&id=0451ce63"
import script from "./VSearchProfileForm.vue?vue&type=script&lang=js"
export * from "./VSearchProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports